jQuery(document).ready(function ($) {

  $('.accordeon-container.close-sections details').each(function () {

    $(this).on('click', function () {
      $('.accordeon-container details').each(function () {
        $(this).removeAttr('open');
      });
    });

  });


  if ($('.form-managed-file label').length >= 1) {
    $('.form-managed-file label').attr('lang', 'en');
  }

  if ($('.webform-submission-form .container').find('h1').length >= 1) {
    $('.webform-submission-form .container').find('h1').replaceWith(function () {
      return $('<h2>', {html: $(this).html()});
    });
  }

});
